import React from 'react'
import { connect } from 'react-redux'

import ProfileMenu from './ProfileMenu'
import { changeLanguageEN, changeLanguageES } from '../../../index'
import Languaje from './languaje'

import './style.scss'
const Translate = require('react-redux-i18n').Translate

const mapDispatchToProps = dispatch => ({
  changeLangEN() {
    changeLanguageEN()
  },
  changeLangES() {
    changeLanguageES()
  },
})

@connect(mapDispatchToProps)
class TopBar extends React.Component {
  render() {
    const { changeLangEN, changeLangES } = this.props
    const userData = window.localStorage.getItem('app.UserData')
      ? JSON.parse(window.localStorage.getItem('app.UserData'))
      : ''
    const enterpriseData = window.localStorage.getItem('enterpriseData')
      ? JSON.parse(window.localStorage.getItem('enterpriseData'))
      : ''

    const returnTitlePage = () => {
      if (userData.email === 'admin@quqo.com') {
        return (
          <div className="col-lg-6">
            <img className="imageMilk" src="resources/quqoImages/acme.png" alt="" />
            <strong className="textTitle">
              <Translate value="application.title" />
            </strong>
          </div>
        )
      } else {
        return (
          <div className="col-lg-6">
            <img className="imageMilk" src={enterpriseData.image} alt="" />
            <strong className="textTitle">{enterpriseData.name}</strong>
          </div>
        )
      }
    }

    return (
      <div className="topbar">
        <div className="row">
          {returnTitlePage()}
          <div className="col-lg-6">
            <div className="row">
              <Languaje />
              <div className="col-12 selectLanguaje" align="right">
                .
              </div>
              <div className="col-12 userPostition">
                <div className="topbar__right">
                  <div className="row">
                    <div className="col-12 profileMenu">
                      <strong className="textUser">{userData.name}</strong>&nbsp;&nbsp;&nbsp;
                      <ProfileMenu />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TopBar



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/TopBar/index.js